import { IonSegment, IonSegmentButton } from "@ionic/react";
import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSupplier } from "redux/container/supplierSlice";

function SellerFilter({
  ekkLanguage,
  setReachedEnd,
  setHasMoreData,
  selectSupplier,
}) {
  const dispatch = useDispatch();
  const locatedSeller = useSelector((state) => state.supplier.data);

  const currentValue = locatedSeller ?? "nearbySeller";

  return (
    <IonSegment
      scrollable
      className="orderBtnWrapper"
      value={currentValue}
      onIonChange={(e) => {
        const value = e.detail.value;
        setHasMoreData(true);
        setReachedEnd(false);
        dispatch(setSupplier(value));
      }}
    >
      {!selectSupplier ? (
        <IonSegmentButton value="purchaseOrder" className="no-ripple recent">
          <button className="text-black font-sans p-0 font-normal shadow-none text-14">
            Purchase Order
          </button>
        </IonSegmentButton>
      ) : (
        ""
      )}
      <IonSegmentButton value="nearbySeller" className="no-ripple recent">
        <button className="text-black font-sans p-0 font-normal shadow-none text-14">
          {ekkLanguage.sellerList.nearBySeller}
        </button>
      </IonSegmentButton>
      <IonSegmentButton value="allSeller" className="no-ripple recent">
        <button className="text-black font-sans p-0 font-normal shadow-none text-14">
          In Country
        </button>
      </IonSegmentButton>
      {!selectSupplier ? (
        <IonSegmentButton value="products" className="no-ripple recent">
          <button className="text-black font-sans p-0 font-normal shadow-none text-14">
            Products
          </button>
        </IonSegmentButton>
      ) : (
        ""
      )}
      <IonSegmentButton value="international" className="no-ripple recent">
        <button className="text-black font-sans p-0 font-normal shadow-none text-14">
          International
        </button>
      </IonSegmentButton>
    </IonSegment>
  );
}

export default memo(SellerFilter);
